import React from "react";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";

const DateRangePicker = ({ dateRange, setDateRange }) => {
  return (
    <div className="flex items-center gap-2">
      {/* Start Date Picker */}
      <div className="relative w-full">
        <DatePicker
          selected={dateRange.startDate}
          onChange={(date) => {
            setDateRange((prev) => ({
              ...prev,
              startDate: date,
            }));
          }}
          selectsStart
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
          placeholderText="กรุณาเลือกช่วงเวลาเริ่มต้น"
          wrapperClassName="w-full"
          className="w-full border rounded-lg py-2 px-3 focus:outline-none focus:ring focus:border-blue-300 pr-10"
          showMonthYearPicker
          dateFormat="MMM yyyy"
        />
        <FaCalendarAlt className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
      </div>

      <span className="font-semibold">ถึง</span>

      {/* End Date Picker */}
      <div className="relative w-full">
        <DatePicker
          selected={dateRange.endDate}
          onChange={(date) => {
            setDateRange((prev) => ({
              ...prev,
              endDate: date,
            }));
          }}
          selectsEnd
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
          minDate={dateRange.startDate}
          wrapperClassName="w-full"
          placeholderText="กรุณาเลือกช่วงเวลาสิ้นสุด"
          className="w-full border rounded-lg py-2 px-3 focus:outline-none focus:ring focus:border-blue-300 pr-10"
          showMonthYearPicker
          dateFormat="MMM yyyy"
        />
        <FaCalendarAlt className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
      </div>
    </div>
  );
};

export default DateRangePicker;
